import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { bankTranslater } from "../../util";
import { set, sum, type } from "ramda";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportWinnerBook = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs, profileState } = Context();
  const [prizes, setPrizes] = useState(false);

  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  const prizeType = {
    first: { label: "รางวัลที่ 1", reward: "6,000,000", index: 1 },
    firstThree: { label: "หน้า 3 ตัว", reward: "4,000", index: 7 },
    fith: { label: "รางวัลที่ 5", reward: "20,000", index: 6 },
    forth: { label: "รางวัลที่ 4", reward: "40,000", index: 5 },
    lastThree: { label: "ท้าย 3 ตัว", reward: "4,000", index: 8 },
    lastTwo: { label: "ท้าย 2 ตัว", reward: "2,000", index: 9 },
    nearBy: { label: "รางวัลไกล้เคียง", reward: "100,000", index: 2 },
    second: { label: "รางวัลที่ 2", reward: "200,000", index: 3 },
    third: { label: "รางวัลที่ 3", reward: "80,000", index: 4 },
  };
  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    const data = await callApi("prizes-getAllLotteriesWithPrize", {
      roundDate: selectedRoundDate,
    });
    console.log("🚀 ~ getOrders ~ data:", data);
    const summary = data.reduce((acc, order) => {
      order.prizes.forEach((prize) => {
        if (acc[prize.prizeType]) {
          acc[prize.prizeType].count += 1;
          acc[prize.prizeType].amount += prize.prizeAmount;
        } else {
          acc[prize.prizeType] = { count: 1, amount: prize.prizeAmount };
        }
      });

      return acc;
    }, {});

    setSummary(summary);
    setPrizes(data.sort((a, b) => a.fileNameId.localeCompare(b.fileNameId)));
    setLoading(false);
  };

  const handleDownload = async () => {
    const data = [
      [`รายงานรางวัลงวด_${selectedRoundDate}`],
      ["ชื่อรางวัล", "รางวัลละ (บาท)", "จำนวนใบ (ใบ)", "มูลค่า (บาท)"],
    ];

    Object.entries(summary).forEach(([key, value]) => {
      data.push([
        prizeType[key].label,
        prizeType[key].reward,
        value.count.toLocaleString(),
        value.amount.toLocaleString(),
      ]);
    });

    data.push([
      "ลำดับ",
      "ชื่อเล่ม",
      "เลขสลาก",
      "คำสั่งซื้อ",
      "รางวัล",
      "มูลค่า",
    ]);
    prizes.forEach((prize, index) => {
      return data.push([
        index + 1,
        prize.fileNameId,
        prize.id.split("-")[3],
        prize.orderShortId,
        prize.prizes
          .map((eachPrize) => `${prizeType[eachPrize.prizeType].label} `)
          .join(", "),
        prize.prizes.reduce((acc, eachPrize) => {
          acc += Number(eachPrize.prizeAmount);
          return acc;
        }, 0),
      ]);
    });
    console.log("🚀 ~ handleDownload ~ prizes:", prizes);
    setCsvData(data);
    setCsvFileName(`รายงานรางวัลงวด_${selectedRoundDate}.csv`);
  };

  let total = 0;
  let count = 0;
  return (
    <div className="h-fit w-full max-w-[1600px] mb-24 mx-auto">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานสรุปรางวัล"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">รายงานสรุปรางวัล</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!prizes.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>

      {prizes && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">สรุปรางวัล</p>{" "}
          </div>
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">ชื่อรางวัล</TableHead>
                <TableHead className="text-right">รางวัลละ (บาท)</TableHead>
                <TableHead className="text-right">จำนวน (ใบ)</TableHead>
                <TableHead className="text-right">มูลค่า (บาท)</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {Object.entries(summary).map(([key, value], index) => {
                total = total + value.amount;
                count = count + value.count;
                return (
                  <TableRow key={index}>
                    <TableCell className={`font-medium`}>
                      {prizeType[key].label || "-"}
                    </TableCell>
                    <TableCell className={`font-medium text-right`}>
                      {prizeType[key].reward || "-"}
                    </TableCell>
                    <TableCell className={`font-medium text-right`}>
                      {value.count.toLocaleString()}
                    </TableCell>{" "}
                    <TableCell className={`font-medium text-right`}>
                      {value.amount.toLocaleString()}
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell className={`font-medium`}>รวม</TableCell>
                <TableCell className={`font-medium text-right`}></TableCell>
                <TableCell className={`font-medium text-right`}>
                  {count.toLocaleString()}
                </TableCell>{" "}
                <TableCell className={`font-medium text-right`}>
                  {total.toLocaleString()}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className={`font-medium`}>
                  รางวัลจากสลากที่ยังไม่ขาย
                </TableCell>
                <TableCell className={`font-medium text-right`}></TableCell>
                <TableCell className={`font-medium text-right`}>
                  {prizes
                    .filter((prize) => !prize.orderShortId)
                    .length.toLocaleString()}{" "}
                </TableCell>{" "}
                <TableCell className={`font-medium text-right`}>
                  {prizes
                    .filter((prize) => !prize.orderShortId)
                    .reduce((acc, prize) => {
                      const prizeAmount = prize.prizes.reduce(
                        (sum, p) => sum + p.prizeAmount,
                        0,
                      );
                      return acc + prizeAmount;
                    }, 0)
                    .toLocaleString()}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}

      {prizes && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">รางวัลทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {prizes.length} รางวัล
            </p>
          </div>
          {/* <ScrollArea className={`h-96`}> */}
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="text-center">ลำดับ</TableHead>
                <TableHead className="">ชื่อเล่ม</TableHead>
                <TableHead className="text-center">เลขสลาก</TableHead>
                <TableHead className="text-center">คำสั่งซื้อ</TableHead>
                <TableHead className="text-right">รางวัล</TableHead>
                <TableHead className="text-right">มูลค่า</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {prizes.length > 0 ? (
                prizes.map((prize, index) => {
                  return (
                    <TableRow key={prize.id}>
                      <TableCell className={`font-medium text-center`}>
                        {index + 1}
                      </TableCell>
                      <TableCell className="font-medium">
                        {prize.fileNameId}
                      </TableCell>
                      <TableCell>
                        <p className="font-mono font-medium tabular-nums text-center">
                          {prize.id.split("-")[3]}
                        </p>
                      </TableCell>
                      <TableCell
                        className={`font-semibold text-center font-mono tabular-nums`}
                      >
                        {prize.orderShortId || (
                          <p className="text-failed">ยังไม่ได้ขาย</p>
                        )}
                      </TableCell>
                      <TableCell className="font-semibold text-right">
                        {prize.prizes.map((eachPrize, index) => {
                          return (
                            <p className="font-semibold" key={index}>
                              {prizeType[eachPrize.prizeType].label}{" "}
                            </p>
                          );
                        })}
                      </TableCell>
                      <TableCell className="font-semibold text-right">
                        {prize.prizes.map((eachPrize, index) => {
                          return (
                            <p className="text-green" key={index}>
                              {prizeType[eachPrize.prizeType].reward}
                            </p>
                          );
                        })}
                      </TableCell>

                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell className="" colSpan="8">
                    <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                      <div>
                        <MdPersonSearch className="text-white" />
                        ไม่พบคำสั่งซื้อ
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* </ScrollArea> */}
        </div>
      )}
    </div>
  );
};
